import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import Card from "components/Card/Card.js";

import carouselStyle from "assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.js";

// import image1 from "assets/img/bg.jpg";
// import image2 from "assets/img/bg2.jpg";
// import image3 from "assets/img/bg3.jpg";

import mybangles24image1 from "assets/img/Landing.jpg";
import mybangles24image2 from "assets/img/Landing1.jpg";
import mybangles24image3 from "assets/img/Landing2.jpg";
import mybangles24image4 from "assets/img/Landing3.jpg";
import mybangles24image5 from "assets/img/Landing4.jpg";

const useStyles = makeStyles(carouselStyle);

export default function SectionCarousel() {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    // <div className={classes.section} id="carousel">
    //   <div className={classes.container}>
        <GridContainer id="carousel">
          <GridItem xs={12} sm={12} md={12} className={classes.marginAuto}>
            {/* <Card> */}
              <Carousel {...settings}>
                <div>
                  <img src={mybangles24image1} alt="mybangles24image1" className="slick-image" />
                  {/* <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Yellowstone National Park, United States
                    </h4>
                  </div> */}
                </div>
                <div>
                  <img
                    src={mybangles24image2}
                    alt="mybangles24image2"
                    className="slick-image"
                  />
                  {/* <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Somewhere Beyond, United States
                    </h4>
                  </div> */}
                </div>
                <div>
                  <img src={mybangles24image3} alt="mybangles24image3" className="slick-image" />
                  {/* <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Yellowstone National Park, United States
                    </h4>
                  </div> */}
                </div>
                <div>
                  <img src={mybangles24image4} alt="mybangles24image4" className="slick-image" />
                  {/* <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Yellowstone National Park, United States
                    </h4>
                  </div> */}
                </div>
                <div>
                  <img src={mybangles24image5} alt="mybangles24image5" className="slick-image" />
                  {/* <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Yellowstone National Park, United States
                    </h4>
                  </div> */}
                </div>
              </Carousel>
            {/* </Card> */}
          </GridItem>
        </GridContainer>
    //    </div>
    //   </div>
  );
}
